import ApiClient from '@/api/ApiClient';

const client = new ApiClient('agency/usertasktemplate');

class UserTaskTemplateApiAgency {

	static grid (userTaskTemplatePagedList?: IUserTaskTemplatePagedListParameters) {
		return client.post<IPagedList<IUserTaskTemplateModel>>('grid', userTaskTemplatePagedList ?? {});
	}

	static add (addUserTaskTemplateModel: IAddUserTaskTemplateModel) {
		return client.post<IUserTaskTemplateModel>('', addUserTaskTemplateModel);
	}

	static update (id: number, updateUserTaskTemplateModel: IUpdateUserTaskTemplateModel) {
		return client.put(id.toString(), updateUserTaskTemplateModel);
	}

	static delete (id: number) {
		return client.delete(id.toString());
	}
}

export default UserTaskTemplateApiAgency;
